export default __webpack_public_path__ + "static/media/tiendaapple.839182a0.png";